import { useRef, useCallback, useEffect } from 'react';

const useScript = innerHTML => {
  const ref = useRef(null);
  const setRef = useCallback(node => {
    if (ref.current) {
      // Make sure to cleanup any events/references added to the last instance
    }

    if (node) {
      // Check if a node is actually passed. Otherwise node would be null.
      // You can now do what you need to, addEventListeners, measure, etc.
    }

    // Save a reference to the node
    ref.current = node;
  }, []);

  useEffect(() => {
    const script = document.createElement('script');

    script.innerHTML =
      `try {
        ${innerHTML}
      } catch (err) {
        console.warn('[Warning] The script does not work properly: ', err);
      }` || '';
    script.async = true;

    if (ref && ref.current) ref.current.appendChild(script);
    else document.body.appendChild(script);

    return () => {
      if (ref && ref.current) ref.current.removeChild(script);
      else document.body.removeChild(script);
    };
  }, [innerHTML]);

  return [setRef];
};

export default useScript;
